// extracted by mini-css-extract-plugin
module.exports = {"serpFastBundlePreloader":"_93444fe79c--serpFastBundlePreloader--K_Apa","serpFastBundlePreloaderSpin":"_93444fe79c--serpFastBundlePreloaderSpin--XWAV0"};